import { render, staticRenderFns } from "./DispatchInfo.vue?vue&type=template&id=8b08fcba"
import script from "./DispatchInfo.vue?vue&type=script&lang=js"
export * from "./DispatchInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports